/**
 * RTK Query endpoints — Flow Types
 *
 * Migrated from: src/redux/flow-types/actions.js
 *
 * Single read-only endpoint. The response shape is `{ flowTypes: [...] }`;
 * we preserve it so the existing dialogs that already iterate
 * `flowTypes.flowTypes` continue to work.
 */

import { baseApi } from './baseApi';

const flowTypeApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    flowTypeList: builder.query({
      query: () => ({ url: '/su/flow-type', method: 'GET' }),
      providesTags: [{ type: 'FlowType', id: 'LIST' }],
    }),
  }),
  overrideExisting: false,
});

export const { useFlowTypeListQuery } = flowTypeApi;
export default flowTypeApi;
